import script from "./PartnerAPIKeysPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./PartnerAPIKeysPanel.vue?vue&type=script&setup=true&lang=js"

import "./PartnerAPIKeysPanel.vue?vue&type=style&index=0&id=9d63bb40&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9d63bb40"]])

export default __exports__